/**
 * Duplicates a MAUI app by calling the Remix duplicate API endpoint.
 *
 * @param appId - The ID of the MAUI app to duplicate
 * @param containerContentId - The Confluence page ID that will contain the duplicated app
 * @param cloudId - Optional cloud ID used to construct the container ARI
 * @returns The ID of the newly duplicated app
 */
export async function duplicateMauiApp(
	appId: string,
	containerContentId: string,
	cloudId?: string,
): Promise<{ id: string }> {
	const containerAri = cloudId
		? `ari:cloud:confluence:${cloudId}:page/${containerContentId}`
		: undefined;

	const response = await fetch(
		`/gateway/api/remix/api/v1/ui/${encodeURIComponent(appId)}/duplicate`,
		{
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				containerAri: containerAri ?? containerContentId,
			}),
		},
	);

	if (!response.ok) {
		throw new Error("We couldn't duplicate this component. Please try again.");
	}

	const data = await response.json();
	if (!data?.id) {
		throw new Error(
			"We couldn't duplicate this component. The server did not return a new component ID.",
		);
	}

	return { id: data.id };
}
